import { getNestedString, useConfig } from '@/utils/useConfig';
import { styled } from '@mui/material/styles';

const Root = styled('div')(({ theme }) => ({
	'& > .logo-icon': {
		transition: theme.transitions.create(['width', 'height'], {
			duration: theme.transitions.duration.shortest,
			easing: theme.transitions.easing.easeInOut
		})
	},
	'& > .badge': {
		transition: theme.transitions.create('opacity', {
			duration: theme.transitions.duration.shortest,
			easing: theme.transitions.easing.easeInOut
		})
	}
}));

/**
 * The logo component.
 */
function Logo() {

	const { config: navbarConfig } = useConfig('navbar_config');

	if (!getNestedString(navbarConfig, 'image')) {
		return null;
  }

  const height = getNestedString(navbarConfig, 'height')

	return (
		<Root className="flex items-center space-x-12">
			<div className="flex items-center space-x-8">
				<img
					className={`logo-icon h-${height ? height : '32'}`}
					src={getNestedString(navbarConfig, 'image')}
					alt="logo"
				/>
				{getNestedString(navbarConfig, 'name') && <div className="logo-text flex flex-col flex-auto gap-2">
					<p className="text-2xl tracking-light font-semibold leading-none">
						{getNestedString(navbarConfig, 'name')}
					</p>
				</div>}
			</div>
		</Root>
	);
}

export default Logo;
